(() => {
  const progress = document.querySelector('[data-article-progress]');
  const article = document.querySelector('[data-kolatoy-article] .blog-post-content');
  const bar = progress?.querySelector('[data-article-progress-bar]');

  if (!progress || !article || !bar || progress.dataset.ready === 'true') return;
  progress.dataset.ready = 'true';
  const pageScroller = document.querySelector('.page-wrapper');
  const scrollContainer = pageScroller || document.scrollingElement;

  const update = () => {
    const stickyHeader = document.querySelector('#header-group .header-section');
    const headerBottom = stickyHeader ? Math.max(0, stickyHeader.getBoundingClientRect().bottom) : 0;
    const progressTop = Math.max(0, Math.round(headerBottom) - 1);
    progress.style.setProperty('--article-progress-top', `${progressTop}px`);
    document.documentElement.style.setProperty('--article-progress-top', `${progressTop}px`);

    const articleRect = article.getBoundingClientRect();
    const containerRect = pageScroller?.getBoundingClientRect();
    const containerTop = containerRect?.top || 0;
    const scrollTop = pageScroller ? pageScroller.scrollTop : window.scrollY;
    const viewportHeight = pageScroller?.clientHeight || window.innerHeight;
    const articleTop = scrollTop + articleRect.top - containerTop;
    const articleBottom = articleTop + article.offsetHeight;
    const visibleHeaderHeight = Math.max(0, headerBottom - containerTop);
    const readingStart = articleTop - visibleHeaderHeight;
    const readingEnd = Math.max(readingStart + 1, articleBottom - viewportHeight + visibleHeaderHeight);
    const percent = Math.min(1, Math.max(0, (scrollTop - readingStart) / (readingEnd - readingStart)));
    const value = Math.round(percent * 100);

    bar.style.transform = `scaleX(${percent})`;
    progress.setAttribute('aria-valuenow', String(value));
  };

  scrollContainer?.addEventListener('scroll', update, { passive: true });
  window.addEventListener('scroll', update, { passive: true });
  document.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  new ResizeObserver(update).observe(article);
  update();
})();
